function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { isBlank } from "imagica-corekit/dist/base/cutil/Extensions";
import { some } from "lodash";
import { VBComponentsMockDataMapping } from "./viewbuilderConfig/VBComponentsMockDataMapping";
import { VBComponentsNameIdMapping } from "./viewbuilderConfig/VBComponentsNameIdMapping";
export var ViewBuilderUtil = /*#__PURE__*/function () {
  function ViewBuilderUtil() {
    _classCallCheck(this, ViewBuilderUtil);
  }
  _createClass(ViewBuilderUtil, null, [{
    key: "useMockData",
    value:
    /**
     * 判断数据是否为空使用mock 数据
     * @param data VBGraphDataBase
     * @param componentName string
     * @returns VBGraphDataBase
     */
    function useMockData(data, component_id) {
      var noUseMockData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var componentName = VBComponentsNameIdMapping[component_id];
      if (noUseMockData) {
        return data;
      }
      if (isBlank(data)) {
        return VBComponentsMockDataMapping[componentName];
      }
      var isEmpty = some(data, function (value) {
        return isBlank(value);
      });
      if (isEmpty) {
        return VBComponentsMockDataMapping[componentName];
      }
      return data;
    }
  }]);
  return ViewBuilderUtil;
}();